import { defineMessages, MessageDescriptor } from 'react-intl';
import { RemoteError } from '../../redux/SharedTypes';

export interface ErrorResponse {
	errorCode: string;
	category: string;
	key: string;
	defaultMessage: string;
}

const errorMessages = defineMessages({
	// General errors
	unexpectedError: {
		id: 'base.unexpectedError',
		defaultMessage: 'Unexpected error',
	},
	someErrors: {
		id: 'base.some_errors',
		defaultMessage: 'Some errors occurred',
	},
	genericError: {
		id: 'base.generic_form_error',
		defaultMessage: 'Some errors occurred. Please try again later or contact support',
	},
	GEN_8: {
		id: 'base.entity_not_found',
		defaultMessage: 'Requested entity was not found',
	},

	// Merchant errors
	MA_0: {
		id: 'merchants.errors.not_supported_currency',
		defaultMessage: 'Not supported currency',
	},
	MA_1: {
		id: 'merchants.errors.pay_or_receive_amount_is_required',
		defaultMessage: 'Pay or receive amount is required',
	},
	MA_2: {
		id: 'merchants.errors.merchant_api_not_enabled',
		defaultMessage: 'Merchant api not enabled',
	},
	MA_3: {
		id: 'merchants.errors.callback_url_invalid',
		defaultMessage: 'Callback url invalid',
	},
	MA_4: {
		id: 'merchants.errors.success_url_invalid',
		defaultMessage: 'Success url invalid',
	},
	MA_5: {
		id: 'merchants.errors.failure_url_invalid',
		defaultMessage: 'Failure url invalid',
	},
	MA_6: {
		id: 'merchants.errors.invalid_merchant_order_status',
		defaultMessage: 'Invalid merchant order status',
	},
	MA_7: {
		id: 'merchants.errors.invalid_receive_account',
		defaultMessage: 'Invalid receive account',
	},
	MA_8: {
		id: 'merchants.errors.invalid_pay_currency',
		defaultMessage: 'Invalid pay currency',
	},
	MA_9: {
		id: 'merchants.errors.merchant_new_crypto_address_limit_reached',
		defaultMessage: 'Merchant new crypto address limit reached',
	},
	MA_11: {
		id: 'merchants.errors.callback_daily_limit_reached',
		defaultMessage: 'Callback daily limit reached',
	},
	MA_12: {
		id: 'merchants.errors.duplicate_order_id',
		defaultMessage: 'Duplicate orderId',
	},
	MA_13: {
		id: 'merchants.errors.callback_failed',
		defaultMessage: 'Callback failed',
	},
	MA_14: {
		id: 'merchants.errors.invoices_limit_reached',
		defaultMessage: 'Invoices limit reached',
	},
	MA_15: {
		id: 'merchants.errors.merchant_api_update_not_supported',
		defaultMessage: 'Merchant api update not supported',
	},
	MA_16: {
		id: 'merchants.errors.insufficient_funds',
		defaultMessage: 'Insufficient funds',
	},
	MA_17: {
		id: 'merchants.errors.verification_required',
		defaultMessage: 'Verification required',
	},
	MA_18: {
		id: 'merchants.errors.merchant_order_paid',
		defaultMessage: 'Merchant order paid',
	},
	MA_19: {
		id: 'merchants.errors.unverified_user',
		defaultMessage: 'Unverified user',
	},
	MA_20: {
		id: 'merchants.errors.invalid_user_email',
		defaultMessage: 'Invalid user email',
	},
	MA_21: {
		id: 'merchants.errors.same_user',
		defaultMessage: 'Same user',
	},

	// Payment button errors
	PB_3: {
		id: 'merchants.new_address_blocked',
		defaultMessage: 'New address blocked',
	},
});

export const isMessageDescription = (value: any): value is MessageDescriptor =>
	value?.id && value?.defaultMessage;

export const isRemoteError = (value: any): value is RemoteError => value?.errorCode;

export const isErrorString = (value: any): value is string => typeof value === 'string';

export const getErrorMessageOrDefault = (error?: RemoteError | MessageDescriptor | string) =>
	isMessageDescription(error)
		? error
		: isRemoteError(error)
		? errorMessages[error.errorCode] || errorMessages.unexpectedError
		: isErrorString(error)
		? errorMessages[error] || error || errorMessages.unexpectedError
		: errorMessages.unexpectedError;

export default errorMessages;
